import { PermissionLevel } from '@miq/domain/property-sets';

export enum PermissionLevelOptions {
  Read = 'View',
  Write = 'View/Manage',
  Owner = 'Owner',
}

export const permissionLevelMap: { [key: number]: PermissionLevelOptions } = {
  [PermissionLevel.Read]: PermissionLevelOptions.Read,
  [PermissionLevel.Write]: PermissionLevelOptions.Write,
  [PermissionLevel.Owner]: PermissionLevelOptions.Owner,
};

export enum ConfidentialityType {
  Level0 = 'Level 0',
  Level1 = 'Level 1',
  Level2 = 'Level 2',
}

export const ConfidentialityTypeMap: { [key: number]: ConfidentialityType } = {
  1: ConfidentialityType.Level0,
  2: ConfidentialityType.Level1,
  3: ConfidentialityType.Level2,
};

export enum PermissionType {
  Group = 'Groups',
  User = 'Users',
}

export enum GroupPermissionFields {
  Role = 'role_desc',
  GlobalRegion = 'region_desc',
  Division = 'division_desc',
  Market = 'market_desc',
  PropertyType = 'usage_type_id',
  ConfidentialityLevel = 'confidentiality_type_id',
  PermissionLevel = 'level',
}

export enum UserPermissionFields {
  UserName = 'user_name',
  Email = 'user_email',
  PermissionLevel = 'level',
}

export const PropertyUsageTypesMap: { [key: number]: string } = {
  0: 'ALL',
  2276: 'Industrial',
  2278: 'Land',
  2275: 'Office',
  2277: 'Retail',
};
